import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { animeDialog, animeBackground, animeSubmodal, animeImgShow } from '../../../modals/animations';
import { Modal } from '../../../model/modal';

import { UsersService } from '../../../services/users.service';
import { DealerPlanService } from '../../../services/service-plan.service';

import { Helper } from '../../../../4services/2helper';
import { lastValueFrom } from 'rxjs';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'dealer-plan-description',
    templateUrl: './dealer-plan-description.component.html',
    styleUrls: ['../../../modals/common.scss', './dealer-plan-description.component.scss'],
    animations: [animeDialog, animeBackground, animeSubmodal, animeImgShow],
    standalone: false
})

export class DealerPlanDescriptionComponent extends BaseComponent implements OnInit {
  @Input() active: boolean;
  @Input() modal: Modal;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  me = this.usersService.me;
  m_warning = new Modal();
  isLoading = false;
  currentPlanType = 1;
  isHasViewPricePermission = false;

  constructor(
    public usersService: UsersService,
    public dealerPlanService: DealerPlanService,
    private helper: Helper,
  ) { super(); }

  ngOnInit() {
    this.isLoading = true
    this.fetchData()
  }

  async fetchData(){
    const dealerId = this.me().dealer_id
    const dealerType = this.me().type
    try {
      await lastValueFrom(this.dealerPlanService.getDealerServicePlanPricing(dealerId, dealerType))
      const plan = await lastValueFrom(this.dealerPlanService.getDealerPlan(dealerId))
      this.currentPlanType = plan?.current_month_service_plan_type
      this.isHasViewPricePermission = this.helper.permission.has('dealer_invoice_read')
      this.isLoading = false
    } catch(err) {
      this.isLoading = false
    }
  }

  closeModal() {
    this.onClose.next(undefined);
  }

  //////////////////////////////////////
  onClickShowChangingPlanModal(plan){
    this.onUpdate.next(plan)
  }

  goToPricingPlanDescription(){
    this.helper.router.navigate_to_service_plan();
    this.closeModal()
  }

  isHasStandardPlanFee(){
    const data = this.dealerPlanService.dealerPlanPriceStandard
    if(!data) return false
    if(typeof data === 'string') {
      return parseInt(data) > 0 ? true : false
    }
  }
}
